let $ = require('jquery');
import ModalView from "../comp/ModalView.js";
import i18n from "../../utils/i18n";
import POS from "../../POS.js";
let DbRecorder = require("../../recorder/DbRecorder.js");
let _ = require("underscore");
import TableSelectModalView from "../comp/TableSelectModalView.js";
import BillSelectModalView from"../comp/BillSelectModalView.js";
import PrintService from "../../service/PrintService.js";
let Backbone = require("backbone");

let main = function () {
    return ModalView.extend({

        initialize: function () {
            if (this.tableSelectModalView == null) {
                this.tableSelectModalView = new TableSelectModalView({
                    collection: new Backbone.Collection(POS.getTables().filter(function (t) {
                        return !t.isWebTable();
                    }))
                });
            }
            if (this.billSelectModalView == null) {
                this.billSelectModalView = new BillSelectModalView();
            }
            this.listenTo(this.tableSelectModalView, "selectTable", this.onChangeTable);
            this.listenTo(this.billSelectModalView, "selectBill", this.onMoveBillItem);
        },

        render: function () {
            this.tableSelectModalView.model.set("collection", new Backbone.Collection(POS.getTables().filter(function (t) {
                return !t.isWebTable();
            })));
            this.tableSelectModalView.render(this.table);    // /pos/emptyTables
            var self = this;
            this.tableSelectModalView.$el.on('hidden.bs.modal', function () {
                self.trigger("closed");
            });
        },
        onMoveBillItem: function (bill, billItems, table) {
            POS.showLoading(true);
            var self = this, jxhr;
            jxhr = $.post("/bill/moveItemOrCreate", {
                restaurantId: POS.getRestaurant().id,
                currentItemId: JSON.stringify(_.map(billItems.models, function (item) {
                    return item.get("id")
                })),
                targetBillId: bill ? bill.get("id") : null,
                targetTableId: table.get("id"),
            });
            jxhr.done(function (response) {
                if (response.success) {
                    _.each(billItems.models, function (billItem) {
                        billItem = DbRecorder.convert2JSON(billItem);
                        billItem.sid = response.beforeBill;
                        billItem.targetTable = POS.getTable(response.targetTable).toJSON();
                        billItem.lastTable = POS.getTable(response.lastTable).toJSON();
                        PrintService.printSwitchBillReceipt(billItem);
                    });
                    self.$el.modal("hide");
                    Backbone.history.navigate("overview", {trigger: true});
                    new ModalView({body: "<h1 class='large' style='text-align: center;'>" + i18n.msg("pos.table.switch.success", table.get("name")) + "</h1>"}).render().$(".modal-footer").hide();
                }
            });
            jxhr.fail(function (response) {
                new ModalView({body: "<h1 class='large' style='color: red; text-align: center;'>" + response.message + "</h1>"}).render().$(".modal-footer").hide();
            });
            jxhr.always(function (response) {
                POS.showLoading(false);
            })
        },
        onChangeTable: function (table) {
            this.billSelectModalView.model.set("collection", table.getCanMoveBillCollection());
            this.billSelectModalView.model.set("targetTable", table);
            this.billSelectModalView.model.set("moveBillItem", this.model);
            this.billSelectModalView.render(this.bill);
            var self = this;
            this.billSelectModalView.$el.on('hidden.bs.modal', function () {
                self.trigger("closed");
            });
        }
    });
};

let exportedValue = main();
export default exportedValue;


// WEBPACK FOOTER //
// ./src/view/table/SwitchItemModalView.js